/**
 */

import { Fixtuur } from '@fixtuur/backpack';
import * as RTK from '@reduxjs/toolkit';
import * as Cache from './options/cache';

type Options = Fixtuur.Configuration.Options.Options;
type Selections = Fixtuur.Configuration.Selections.Selections;

export interface State {
    options: {
        all: Options | null;
        // Should be used for displaying and considering incompatiblity of build options only
        build: Options | null;
        // should be used for displaying and considering incompatibility of product options only
        product: Options | null;
    };

    // The Selections currently being requested
    pending: {
        build: Selections | null;
        product: Selections | null;
    };

    cache: Cache.Cache;

    pendingInitialisation: boolean;
    allOptionsInitialisedWithGroupingCode: boolean; // TODO: something better
}

export const initialState: State = {
    options: {
        all: null,
        build: null,
        product: null,
    },
    pending: {
        build: null,
        product: null,
    },
    cache: {},
    pendingInitialisation: false,
    allOptionsInitialisedWithGroupingCode: false,
};

export const slice = RTK.createSlice({
    name: 'options',
    initialState,
    reducers: {
        setAllOptions(state, action: RTK.PayloadAction<Options>) {
            state.options.all = action.payload;
        },
        setBuildOptions(state, action: RTK.PayloadAction<Options>) {
            state.options.build = action.payload;
        },
        setProductOptions(state, action: RTK.PayloadAction<Options>) {
            state.options.product = action.payload;
        },
        setCachedOption(
            state,
            action: RTK.PayloadAction<{
                key: Selections;
                options: Options;
            }>,
        ) {
            // Immer messes with the types in ways that are awkward to work around but ultimately don't matter - hence the as casting here
            const cache = state.cache as Cache.Cache;
            state.cache = Cache.insert(
                action.payload.key,
                action.payload.options,
            )(cache) as Cache.Cache;
        },
        setPendingBuildOptions(state, action: RTK.PayloadAction<Selections | null>) {
            state.pending.build = action.payload;
        },
        setPendingProductOptions(state, action: RTK.PayloadAction<Selections | null>) {
            state.pending.product = action.payload;
        },
        setPendingInitialisation(state, action: RTK.PayloadAction<boolean>) {
            state.pendingInitialisation = action.payload;
        },
        setAllOptionsInitialisedWithGroupingCode(state, action: RTK.PayloadAction<boolean>) {
            state.allOptionsInitialisedWithGroupingCode = action.payload;
        },
        reset() {
            return initialState;
        },
    },
});

export const {
    setAllOptions,
    setBuildOptions,
    setProductOptions,
    setCachedOption,
    setPendingBuildOptions,
    setPendingProductOptions,
    setPendingInitialisation,
    setAllOptionsInitialisedWithGroupingCode,
    reset,
} = slice.actions;

export const reducer = slice.reducer;
